<template>
  <div class="report-firewall-summary">
    <div class="search-area">
      <el-select v-model="query.by" placeholder="Select" @change="clearData">
        <el-option
          v-for="item in [
            { label: 'Date', value: 'date' },
            { label: 'Year', value: 'year' },
          ]"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-select v-model="query.year" placeholder="Year" style="width:100px" v-if="query.by === byYear">
            <el-option
                v-for="item in year_option"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              ></el-option>
          </el-select>

      <el-date-picker
        v-model="dateSearch"
        type="daterange"
        range-separator="To"
        start-placeholder="Start date"
        end-placeholder="End date"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        v-else
      >
      </el-date-picker>
      <el-button
        slot="append"
        type="primary"
        icon="el-icon-search"
        @click="getSummaryFirewall()"
        :loading="loading"
        >Search</el-button
      >
      <el-button icon="el-icon-download" type="success" @click="Report()"
        >Export</el-button
      >
    </div>

    <data-tables 
          v-loading="loading" 
          :data="tableData" 
          border 
          :page-size="10"
          :pagination-props="{ background: true, pageSizes: [10, 20, 50, 100, 200] }">
          <el-table-column prop="month" :label="query.by === byYear ? 'Year' : 'Month'" header-align="center" align="center" width="100"> </el-table-column>
          <el-table-column prop="totalTransaction" label="Total Transaction" header-align="center" align="center" min-width="80"> </el-table-column>
          <el-table-column prop="countHitTransaction" label="Count Hit Transaction" header-align="center" align="center" min-width="100"> </el-table-column>
          <el-table-column prop="totalHitVolume" label="Total Hit Volume" header-align="center" align="center" min-width="80"> </el-table-column>
          <el-table-column prop="payinHit" label="Payin" header-align="center" align="center" min-width="120"></el-table-column>
          <el-table-column prop="payoutHit" label="Payout" header-align="center" align="center" min-width="120"></el-table-column>
          <el-table-column prop="approved" label="Approved" header-align="center" align="center" min-width="90"> </el-table-column>
          <el-table-column prop="declined" label="Declined" header-align="center" align="center" min-width="90"> </el-table-column>
          <el-table-column prop="wait" label="Wait" header-align="center" align="center" min-width="90"> </el-table-column>


        </data-tables>
  </div>
</template>

<script>
import { getFirewallSummary, reportFirewallSummaryExcel } from "@/api/firewall-report";
import { currentDateTime, dateFormat, currentYear} from "@/utils";
export default {
  props: {
    project: String,
  },
  watch: {
      project(val, old) {
        this.project = val;
        this.getSummaryFirewall()
      }
  },
  data() {
    return {
      loading: false,
      dateSearch: "",
      byDate: "date",
      byYear: "year",
      tableData: [],
      year_option: [],
      query: {
        by: "date",
        year: currentYear(),
        startDate: "",
        endDate: "",
      },
    };
  },
  methods: {
    SelectDate() {
      if (!this.project) {
        this.$confirm("Please select project", "Warning", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        })
          .then(() => {})
          .catch(() => {});
        return false;
      }

      let formData = { ...this.query };
      if (formData.by === this.byDate) {
        delete formData.year;
        formData.startDate =
          this.dateSearch[0] ||
          currentDateTime("YYYY-MM-DD");
        formData.endDate =
          this.dateSearch[1] ||
          currentDateTime("YYYY-MM-DD");
      } else {
        delete formData.startDate;
        delete formData.endDate;
      }

      return formData;
    },
    clearData(){
      this.tableData=[] 
    },
    getSummaryFirewall() {
      const formData = this.SelectDate();
      if (!formData) return false;
      this.loading = true;
      getFirewallSummary(this.project, formData).then(
        ({ result, data }) => {
          this.loading = false;
          if (result) {
            this.tableData = data
          }
        }
      );
    },
    Report() {
      const formData = this.SelectDate();
      if (!formData) return false;
      reportFirewallSummaryExcel(this.project, formData)
    },

    dropdownMonthYear() {
      for (let y = (currentYear() - 5); y <= currentYear(); y++) {
        this.year_option.push({ value: y.toString() });
      }
    },
  },

  created(){
    this.dropdownMonthYear()
  }

};
</script>

<style lang="scss">
.report-firewall-summary {
  .search-area {
    margin-bottom: 16px;
    button {
      margin-left: 10px;
      margin-bottom: 16px;
    }
    .el-date-editor, .el-select {
      margin-left: 10px;
      margin-bottom: 16px;
    }
  }

  .el-tag{
    text-transform: capitalize;
  }
}
</style>